export var MARKET_AUSTRIA='AT';export var MARKET_GERMANY='DE';